module.exports = "/_next/static/images/Hero@2x-9a175b3b5324409dbbb44594215e122c.webp";